module.exports = __webpack_public_path__ + "static/media/splash.355d0061.png";